import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useSessionData } from '@confluence/session-data';
import { fg } from '@confluence/feature-gating';

interface OperationCheckResult {
	operation: string;
	__typename: 'OperationCheckResult';
}

type UseIsAIEnabledForContentProps = {
	contentId: string;
};

const useIsAIEnabledForContentQuery = gql`
	query useIsAIEnabledForContentQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				operations {
					operation
				}
			}
		}
	}
`;

const isAIReadAllowed = (operationsList: OperationCheckResult[]): boolean => {
	if (operationsList) {
		return operationsList.some((item) => item.operation === 'ai_read');
	} else {
		return false;
	}
};

export const useIsAIEnabledForContent = ({
	contentId,
}: UseIsAIEnabledForContentProps): { isAIEnabledForContent: boolean } => {
	const { isAdminHubAIEnabled } = useSessionData();

	const { data } = useQuery(useIsAIEnabledForContentQuery, {
		variables: {
			contentId,
		},
		skip: !isAdminHubAIEnabled || !fg('confluence_ai_access_policy'),
	});

	if (!fg('confluence_ai_access_policy')) return { isAIEnabledForContent: isAdminHubAIEnabled };

	return {
		isAIEnabledForContent: isAIReadAllowed(data?.content?.nodes[0]?.operations),
	};
};
